<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/final-logo.gif"> -->
    <Faxeslist msg="Welcome to PharmFax.com"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Faxeslist from '@/components/Faxeslist.vue'

export default {
  name: 'Faxes',
  components: {
    // HelloWorld,
    Faxeslist
  }
}
</script>
